export type StudioMode = 'development' | 'production'

export const config = {
	apiUrl: import.meta.env.VITE_STUDIO_SERVER,
	selfcareUrl: import.meta.env.VITE_SELFCARE_APP_URL ?? 'https://selfcare.eu.contember.cloud',

	mode: (import.meta.env.VITE_STUDIO_MODE ?? 'production') as StudioMode,
}
